import { render, staticRenderFns } from "./Vigilantes.vue?vue&type=template&id=25ad1f26"
import script from "./Vigilantes.vue?vue&type=script&lang=js"
export * from "./Vigilantes.vue?vue&type=script&lang=js"
import style0 from "./Vigilantes.vue?vue&type=style&index=0&id=25ad1f26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports